import "./ProfileAvatar.css";
import React from "react";

const DEFAULT_PROFILE_IMAGE_URLS = ["https://assets.gluedin.io/Profile.png"];
const PROFILE_FALLBACK_COLORS = [
  "#F97316",
  "#06B6D4",
  "#22C55E",
  "#8B5CF6",
  "#EF4444",
  "#0EA5E9",
  "#EAB308",
  "#EC4899",
];

interface ProfileAvatarProps {
  imageUrl?: string;
  fullName?: string;
  userName?: string;
  alt?: string;
  imgClassName?: string;
  fallbackClassName?: string;
  defaultImageUrls?: string[];
}

const getProfileInitial = (name?: string) => {
  const trimmedName = name?.trim();
  if (!trimmedName) return "U";
  return trimmedName.charAt(0).toUpperCase();
};

const getFallbackColor = (seed?: string) => {
  if (!seed) return PROFILE_FALLBACK_COLORS[0];
  const hash = seed
    .split("")
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return PROFILE_FALLBACK_COLORS[hash % PROFILE_FALLBACK_COLORS.length];
};

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  imageUrl,
  fullName,
  userName,
  alt,
  imgClassName,
  fallbackClassName,
  defaultImageUrls,
}) => {
  const safeImageUrl = typeof imageUrl === "string" ? imageUrl.trim() : "";
  const displayName = (fullName || userName || "").trim();
  const defaultUrls = new Set(
    (defaultImageUrls?.length ? defaultImageUrls : DEFAULT_PROFILE_IMAGE_URLS).map(
      (url) => url.trim()
    )
  );

  const shouldShowFallback = !safeImageUrl || defaultUrls.has(safeImageUrl);

  if (shouldShowFallback) {
    const fallbackClasses = `common-profile-avatar-fallback ${
      fallbackClassName ?? ""
    }`.trim();
    return (
      <div
        className={fallbackClasses}
        style={{ backgroundColor: getFallbackColor(displayName || userName) }}
        aria-label={alt || displayName || "profile-avatar"}
      >
        {getProfileInitial(displayName || userName)}
      </div>
    );
  }

  return (
    <img
      src={safeImageUrl}
      alt={alt || displayName || "profile-avatar"}
      className={imgClassName}
    />
  );
};

export default ProfileAvatar;
